import type { RelatedProgramsItemProps, RelatedProgramsProps } from "./types";
import OpenUrl from "./openURL.webp?w=32&h=32&jsx";
import { ImageWithoutSizes } from "~/components/ui/ImageWithoutSizes";
import { CHANNEL_LOGO_HEIGHT, CHANNEL_LOGO_WIDTH } from "~/constants/images";

const RelatedItem = ({ channel, info, href }: RelatedProgramsItemProps) => {
  return (
    <>
      <a class="sgtv-group sgtv-flex" href={href}>
        <div class="sgtv-flex sgtv-h-full sgtv-w-[33%] sgtv-items-center">
          <img
            class="sgtv-max-h-12.5 sgtv-w-auto"
            src={channel.src}
            alt={channel.name}
            width={CHANNEL_LOGO_WIDTH}
            height={CHANNEL_LOGO_HEIGHT}
          />
        </div>
        <div class="sgtv-flex sgtv-h-full sgtv-w-[47%] sgtv-flex-col sgtv-items-center sgtv-justify-center sgtv-text-base group-hover:sgtv-text-accent-400">
          {info.map((value, idx) => {
            if (value) {
              return (
                <p
                  class="sgtv-w-full sgtv-truncate sgtv-text-center sgtv-leading-8"
                  key={`${value}_${idx}`}
                >
                  {value}
                </p>
              );
            }
            return null;
          })}
        </div>
        <div class="sgtv-flex sgtv-w-1/5 sgtv-items-center sgtv-justify-end sgtv-pr-3">
          <OpenUrl />
        </div>
      </a>
      <hr class="sgtv-h-px sgtv-text-accent-400"></hr>
    </>
  );
};

export const SidebarRelatedPrograms = ({
  backdropUrl,
  title,
  items,
  class: className,
}: RelatedProgramsProps) => {
  return (
    <div class={className}>
      <div class="sgtv-relative sgtv-overflow-hidden sgtv-pt-[62%]">
        <ImageWithoutSizes
          src={backdropUrl}
          alt={title}
          class="sgtv-absolute sgtv-left-0 sgtv-top-0 sgtv-h-full sgtv-w-full sgtv-object-cover sgtv-object-top"
        />
        <p class="sgtv-absolute sgtv-bottom-0 sgtv-h-10 sgtv-w-full sgtv-truncate sgtv-bg-black/50 sgtv-pl-3 sgtv-text-xl sgtv-leading-10 sgtv-text-white">
          {title}
        </p>
      </div>
      {items.map((item, idx) => {
        return <RelatedItem key={`${item.info}_${idx}`} {...item} />;
      })}
    </div>
  );
};
